import Head from "next/head";
import { make as UnitsInfoPage } from "../../../../src/info/UnitsInfoPage.bs";

export default function UnitsInfo() {
  return (
    <>
      <Head>
        <title>Units Set 4.5 TFT Info & Best Item Builds</title>
      </Head>
      <UnitsInfoPage set={46} />
    </>
  );
}
